// Auto-generated by scripts/generate-build-info.mjs. Do not edit.
export const buildInfo = {
    commit: 'c26d88e',
    builtAt: '2026-10-29T17:47:35.397Z',
} as const;
